import React from 'react';
import PropTypes from 'prop-types';

import styles from './success-factors.module.scss';

export const SuccessFactors = ({ data }) => (
	<div className={styles.wrapper}>
		<div className={styles.container}>
			<h2>{data.header}</h2>
			<div className={styles.items}>
				{data.items.map((item, key) => (
					<div key={key} className={styles.item}>
						<h3>{item.title}</h3>
						<div>{item.text}</div>
					</div>
				))}
			</div>
		</div>
	</div>
);

SuccessFactors.defaultProps = {
	data: {},
};

SuccessFactors.propTypes = {
	data: PropTypes.object.isRequired,
};
